import styled from "styled-components";

const InputCalendarGroup = styled.div`
    padding-bottom: 1.5rem;
`;

export default InputCalendarGroup;
